'use client';

import { getPassportProfileUrl } from '@/libs/passport/profile-link';
import { useAuthStore } from '@/stores/auth/auth.store';

/** Resolve the signed-in identity on the Passport instance that authorized it. */
export function usePassportProfileUrl() {
  const publicKey = useAuthStore((state) => state.currentUserPubky);
  const instance = useAuthStore((state) => state.passportInstance);
  return publicKey ? getPassportProfileUrl(publicKey, instance) : null;
}
